import { Routes } from "@datadog/browser-rum-react/react-router-v6";
import { Navigate, Route } from "react-router-dom";

import { DatadogRumSectionBoundary } from "@/components/DatadogRumSectionBoundary";
import PrivateLayout from "@/components/PrivateLayout";
import { ROUTES_URL } from "@/constant";
import AppCustomerConsent from "@/pages/AppCustomerConsent";
import AppCustomerConsentApproval from "@/pages/AppCustomerConsentApproval";
import CustomerConsent from "@/pages/CustomerConsent";
import Dashboard from "@/pages/Dashboard";
import DueDiligence from "@/pages/DueDiligence";
import ForgotPassword from "@/pages/ForgotPassword";
import Login from "@/pages/Login";
import NotFound from "@/pages/NotFound";
import Notification from "@/pages/Notification";
import PaymentPOC from "@/pages/PaymentPOC";
import Pledge from "@/pages/Pledge";
import PledgeConsentApproval from "@/pages/PledgeConsentApproval";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import ResetPassword from "@/pages/ResetPassword";
import Settings from "@/pages/Setting";
import Terms from "@/pages/Terms";
import Transactions from "@/pages/Transaction";
import ViewPledgeTicket from "@/pages/ViewPledgeTicket";

const RouteList: React.FC = () => {
  return (
    <Routes>
      <Route element={<DatadogRumSectionBoundary />}>
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Public Routes */}
        <Route path={ROUTES_URL.LOGIN} element={<Login />} />
        <Route path={ROUTES_URL.FORGOT_PASSWORD} element={<ForgotPassword />} />
        <Route path={ROUTES_URL.RESET_PASSWORD} element={<ResetPassword />} />
        <Route path={ROUTES_URL.PRIVACY_POLICY} element={<PrivacyPolicy />} />
        <Route path={ROUTES_URL.TERMS} element={<Terms />} />
        <Route path={ROUTES_URL.PLEDGE_CONSENT_APPROVAL} element={<PledgeConsentApproval />} />
        <Route path={ROUTES_URL.APP_CUSTOMER_CONSENT} element={<AppCustomerConsent />} />
        <Route
          path={ROUTES_URL.APP_CUSTOMER_CONSENT_APPROVAL}
          element={<AppCustomerConsentApproval />}
        />
        <Route path={"/payment-poc"} element={<PaymentPOC />} />

        {/* Private Route Group */}
        <Route element={<PrivateLayout />}>
          <Route path={ROUTES_URL.DASHBOARD} element={<Dashboard />} />
          <Route path={ROUTES_URL.TRANSACTIONS} element={<Transactions />} />
          <Route path={ROUTES_URL.NOTIFICATIONS} element={<Notification />} />
          <Route path={ROUTES_URL.PLEDGE} element={<Pledge />} />
          <Route path={ROUTES_URL.PLEDGE_PAYMENT} element={<Pledge />} />
          <Route path={ROUTES_URL.SETTINGS} element={<Settings />} />
          <Route path={ROUTES_URL.CUSTOMER_CONCENT} element={<CustomerConsent />} />
          <Route path={ROUTES_URL.DUE_DILIGENCE} element={<DueDiligence />} />
          <Route path={ROUTES_URL.VIEW_PLEDGE_TICKET} element={<ViewPledgeTicket />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default RouteList;
